<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded01">
<p class="dedicationText"><em class="italic">For:</em></p>
<p class="dedicationText"><em class="italic">Alice Anne Carroll, my grandmother</em></p>
<p class="dedicationText"><em class="italic">Emily Carroll Bell, my mother</em></p>
<p class="dedicationText"><em class="italic">Alice Carroll George Davidson, my daughter</em></p>
<p class="dedicationText"><em class="italic">Emily Anne Davidson, my granddaughter</em></p>
<p class="dedicationText1"><em class="italic">How impossible to contend</em></p>
<p class="dedicationText1"><em class="italic">Where I stop and you begin.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?529ec311